import styled from "styled-components"

const ContentCard = ({
						 title,
						 size = "normal",
						 media = null,
						 textColor = null,
						 reverse = false,
						 children,
					 }) => {
	const Title = () => {
		switch (size) {
			case "large":
				return <h1>{title}</h1>
			case "normal":
				return <h2>{title}</h2>
			case "small":
				return <h3>{title}</h3>
			case "mini":
				return <h4>{title}</h4>
			default:
				return <h2>{title}</h2>
		}
	}

	return (
		<Wrapper $reverse={reverse} $textColor={textColor}>
			{media && (
				<Image $radius={media.radius} $maxWidth={media.maxWidth}>
					<img src={media.url} alt={title} loading="lazy"/>
				</Image>
			)}
			<Desc $hasMedia={!!media}>
				<Title/>
				{children}
			</Desc>
		</Wrapper>
	)
}

export default ContentCard

const Wrapper = styled.div`
    display: flex;
    flex-direction: ${({$reverse}) => ($reverse ? "row-reverse" : "row")};
    align-items: center;
    gap: 3rem;
    color: ${({$textColor}) => $textColor ?? "#000"};

    @media (max-width: 992px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }
`

const Image = styled.div`
    max-width: 65%;

    img {
        width: 100%;
        display: block;
        border-radius: ${({$radius}) =>
                $radius >= 0 ? $radius : 1.88}rem;
        max-width: ${({$maxWidth}) =>
                $maxWidth ? $maxWidth + "rem" : "100%"};
    }

    @media (max-width: 992px) {
        max-width: 100%;
    }
`

const Desc = styled.div`
    max-width: ${({$hasMedia}) => ($hasMedia ? 35 : 70)}%;

    @media (max-width: 992px) {
        max-width: 100%;
        text-align: left;
    }
`
